<template>
  <v-dropdown
    popper-class="floating-menu"
    :placement="placement"
    :distance="distance"
    :arrow-overflow="false"
    :delay="100"
  >
    <button
      @click.stop
      class="menu__action"
    >
      <fa-icon
        class="icon"
        :icon="['fal', 'ellipsis']"
      />
    </button>

    <template #popper="{ hide }">
      <slot
        name="options"
        :hide="hide"
      />
    </template>
  </v-dropdown>
</template>

<script setup>
import { Dropdown as VDropdown } from 'floating-vue'

defineProps({
  placement: { type: String, default: 'bottom-end' },
  distance: { type: Number, default: 3 }
})
</script>

<style scoped lang="scss">
.menu {
  &__action {
    border: 1px solid $dw;
    border-radius: 6px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $white;
    transition: all .3s;
    cursor: pointer;

    .icon {
      color: $lg;
    }

    &:hover {
      border-color: rgba($black, .5);
      background-color: $vdw;

      .icon {
        color: rgba($black, .5);
      }
    }
  }
}
</style>